<template>
  <Teleport to="body">
    <Dialog v-model:visible="showNews" :style="{ width: '50vw', maxWidth: '90vw' }" modal @hide="hideDialog">
      <template #header>
        <i class="pi pi-exclamation-circle mr-3" :style="{ 'font-size': '2rem', color: 'rgb(204,51,0)' }" />
        <div class="font-bold text-center" style="font-size: 20px">
          Уведомления и новости
        </div>
      </template>
      <div class="news-container">
        <div v-for="(item, index) in news" :key="index" class="news-item mb-3 p-3 shadow-1" :style="{
          borderLeft: `4px solid ${item.news_severity_color || '#ccc'}`,
          backgroundColor: '#f8f9fa',
        }">
          <div class="flex align-items-center mb-2">
            <i class="pi pi-bell mr-2" :style="{ color: item.news_severity_color || '#ccc' }" />
            <h4 class="m-0" style="color: #333; font-weight: 500">
              {{ item.news_title }}
            </h4>
          </div>
          <div class="news-description mb-3" v-html="item.news_desc" />
          <div class="flex align-items-center">
            <Checkbox binary :inputId="'show-again' + index" v-model="item.news_disabled" class="mr-2"
              @change="onChangeCheck(item)" />
            <label :for="'show-again' + index" style="color: #666; cursor: pointer">
              Не показывать больше
            </label>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="flex justify-content-end">
          <Button label="Ок" icon="pi pi-check" class="p-button-text" @click="showNews = false" />
        </div>
      </template>
    </Dialog>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';

const store = useStore();
const toast = useToast();

const showNews = ref(false);
const news = ref([]);

let newsService = null;
let timer = null;

const initializeService = () => {
  const { login, password } = store.getters;
  newsService = store.getters.nameToService(
    'BaseService',
    login,
    password,
    'news',
    'today'
  );
}

const fetchNews = () => {
  if (!newsService) return;

  newsService
    .getData()
    .then((data) => {
      news.value = data;
      if (news.value.length) {
        timer = setTimeout(() => {
          showNews.value = true;
        }, 900);
      }
    })
    .catch((error) => {
      console.error('Failed to fetch news:', error);
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Не удалось загрузить уведомления. Проверьте подключение к серверу.',
        life: 3000,
      });
    });
}

const saveNewsView = () => {
  if (!newsService) return;
  newsService.execProc('news.news__view').catch((error) => {
    console.error('Failed to save news view:', error);
  });
}

const onChangeCheck = (item) => {
  if (!newsService) return;

  newsService
    .execProc('news.news__disable', {
      news_id: item.news_id,
      news_disabled: item.news_disabled,
    })
    .catch(() => {
      toast.add({
        severity: 'warn',
        summary: 'Предупреждение',
        detail: 'Не удалось изменить состояние уведомления. Попробуйте обновить страницу.',
        life: 3000,
      });
      item.news_disabled = !item.news_disabled;
    });
}

const hideDialog = () => {
  saveNewsView();
}

onMounted(() => {
  initializeService();
  fetchNews();
})

onUnmounted(() => {
  if (timer) clearTimeout(timer);
})
</script>

<style scoped>
.news-container {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0.5rem;
}

.news-item {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.news-item:hover {
  background: #e9ecef !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.news-description {
  color: #495057;
  line-height: 1.5;
}

.news-description :deep(*) {
  margin-bottom: 0.5rem;
}

.news-description :deep(p:last-child) {
  margin-bottom: 0;
}

.news-description :deep(a) {
  color: #007bff;
  text-decoration: none;
}

.news-description :deep(a:hover) {
  text-decoration: underline;
}

.news-description :deep(ul) {
  padding-left: 1.5rem;
}

.news-description :deep(li) {
  margin-bottom: 0.25rem;
}

.news-description :deep(h1, h2, h3, h4, h5, h6) {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.news-description :deep(blockquote) {
  border-left: 4px solid #007bff;
  padding-left: 1rem;
  margin-left: 0;
  color: #6c757d;
  font-style: italic;
}

.news-description :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.news-description :deep(th, td) {
  border: 1px solid #dee2e6;
  padding: 0.5rem;
  text-align: left;
}

.news-description :deep(th) {
  background-color: #f8f9fa;
  font-weight: 600;
}

</style>